"use client";
import React, { useState } from "react";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { cn } from "@/lib/utils";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from 'yup';
import { errorNotify, successNotify } from "@/hooks/toast";
import { AddReviewOrCareerForm } from '@/API/response';

export function ContactForm() {
  const [loading, setLoading] = useState(false);
  const route = '/contact/add';

  const initialValues = {
    name: '',
    email: '',
    message: '', 
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required('Full Name is required')
      .min(3, 'Full Name must be at least 3 characters'),
      email: Yup.string()
      .email('Invalid email format')
      .required('Email is required'),
      message: Yup.string()
        .required('Meassage is required')
        .min(10, 'Meassage is too short'),
     
  });

  const handleSubmit = async (values, { resetForm }) => {
    try {
      setLoading(true);
      const response = await AddReviewOrCareerForm(route, values);
      setLoading(false);

      if (response.message === "Message Sent Successfully") {
        successNotify("Message sent successfully");
        resetForm();
      } else {
        errorNotify(response.message || "Something went wrong");
      }
    } catch (error) {
      setLoading(false);
      console.log(error.response?.data);
      errorNotify(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className=" max-w-md w-full mx-auto rounded-2xl px-6 py-10 md:py-12">
      <h2 className="font-bold text-3xl md:text-4xl text-white tracking-tight">
        Contact Us
      </h2>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema} 
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form className=" ">
            <LabelInputContainer>
              <Label htmlFor="name">Name</Label>
              <Field
                id="name"
                name="name"
                placeholder="Your Name"
                type="text"
                as={Input} 
              />
              <ErrorMessage name="name" component="div" className="text-red-500 text-sm" />
            </LabelInputContainer>

            <LabelInputContainer className="mb-4">
              <Label htmlFor="email">Email Address</Label>
              <Field
                id="email"
                name="email"
                placeholder="projectmayhem@fc.com"
                type="email"
                as={Input}
              />
              <ErrorMessage name="email" component="div" className="text-red-500 text-sm" />
            </LabelInputContainer>

            <LabelInputContainer className="mb-8">
              <Label htmlFor="message">Message</Label>
              <Field
                id="message"
                name="message"
                placeholder="Your message..."
                as="textarea"
                rows={6}
                className="flex h-24 w-full border-none bg-zinc-800 text-white rounded-md px-3 py-2 text-sm 
                placeholder:text-neutral-400 dark:placeholder-text-neutral-600 
                focus-visible:ring-neutral-600 disabled:cursor-not-allowed disabled:opacity-50 
                shadow-[0px_0px_1px_1px_var(--neutral-700)] group-hover/input:shadow-none 
                transition duration-400" 
              />
              <ErrorMessage name="message" component="div" className="text-red-500 text-sm" />
            </LabelInputContainer>

            <button
              className="btn-primary relative group/btn block w-full !rounded-md h-11"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <span className="loader">Loading....</span>
              ) : (
                <>
                  Submit &rarr;
                  <BottomGradient />
                </>
              )}
            </button>

            <div className="bg-gradient-to-r from-transparent via-neutral-700 to-transparent my-8 h-[1px] w-full" />
          </Form>
        )}
      </Formik>
        <ToastContainer/>
    </div>
  );
}

const BottomGradient = () => {
  return (
    <>
      <span className="group-hover/btn:opacity-100 block transition duration-500 opacity-0 absolute h-px w-full -bottom-px inset-x-0 bg-gradient-to-r from-transparent via-cyan-500 to-transparent" />
      <span className="group-hover/btn:opacity-100 blur-sm block transition duration-500 opacity-0 absolute h-px w-1/2 mx-auto -bottom-px inset-x-10 bg-gradient-to-r from-transparent via-indigo-500 to-transparent" />
    </>
  );
};

const LabelInputContainer = ({ children, className }) => {
  return (
    <div className={cn("flex flex-col space-y-2 w-full", className)}>
      {children}
    </div>
  );
};